export const EstimateEditDialogTitle = {
  add: '見積新規登録',
  update: '見積情報編集',
};
